var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCitroen = function SvgCitroen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1502 23.8773C27.3359 23.3168 27.4828 22.7279 27.5859 22.1147L19.8747 16.4352L12.163 22.1152C12.2586 22.6844 12.3921 23.2327 12.5594 23.7567L19.8745 18.4434L27.1502 23.8773ZM26.3407 25.7309L19.8745 21.0349L13.3992 25.715C14.8564 28.3528 17.2782 30.0112 19.8744 30.0112C22.4653 30.0112 24.8826 28.3595 26.3407 25.7309ZM19.8744 9.98876C23.9561 9.98876 27.6069 14.0882 27.7553 19.648L19.8747 13.8438L11.9935 19.6485C12.1416 14.0884 15.7926 9.98876 19.8744 9.98876ZM19.8744 31C24.7756 31 28.7487 26.0751 28.7487 20C28.7487 13.9249 24.7756 9 19.8744 9C14.9732 9 11 13.9249 11 20C11 26.0751 14.9732 31 19.8744 31Z",
    fill: "currentColor"
  })));
};
export default SvgCitroen;